<script lang="ts">
	import { richtext, Block, type RichtextStoryblok } from '#library/storyblok.svelte.ts'
	import type { StoryblokRichtext } from '#library/components.schema.build.ts'

	interface Props {
		content?: StoryblokRichtext
	}

	let { content }: Props = $props()

	function render_node(node: RichtextStoryblok) {
		return richtext({
			type: 'doc',
			content: [node]
		})
	}
</script>

{#if content?.content}
	{#each content.content as Array<RichtextStoryblok> as node, index (index)}
		{#if node.type === 'blok' && node.attrs?.body}
			{#each node.attrs.body as blok (blok._uid)}
				<Block {blok} />
			{/each}
		{:else}
			{@html render_node(node)}
		{/if}
	{/each}
{:else}
	{content}
{/if}
